var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeauty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFF0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4487 31.477C21.4486 30.9135 21.6155 30.3627 21.9285 29.8942C22.2414 29.4256 22.6863 29.0604 23.2068 28.8447C23.7273 28.629 24.3001 28.5725 24.8527 28.6823C25.4053 28.7922 25.913 29.0634 26.3114 29.4618C26.7099 29.8601 26.9813 30.3677 27.0912 30.9203C27.2012 31.4729 27.1448 32.0457 26.9293 32.5663C26.7137 33.0869 26.3485 33.5318 25.8801 33.8449C25.4116 34.1579 24.8608 34.325 24.2974 34.325C22.724 34.325 21.5927 33.0437 21.4487 31.477ZM21.4487 31.477L19.614 11.667L17.7794 31.477M17.7794 31.477C17.6347 33.0437 16.5034 34.325 14.93 34.325C14.3666 34.3249 13.8159 34.1577 13.3475 33.8445C12.8791 33.5314 12.5141 33.0864 12.2986 32.5658C12.0831 32.0453 12.0269 31.4725 12.1369 30.9199C12.2469 30.3674 12.5184 29.8598 12.9169 29.4615C13.3153 29.0632 13.823 28.7921 14.3756 28.6823C14.9282 28.5725 15.501 28.629 16.0215 28.8448C16.5419 29.0605 16.9867 29.4257 17.2996 29.8942C17.6126 30.3628 17.7795 30.9136 17.7794 31.477Z",
    stroke: "#FF48A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3965 36.3334C13.0932 36.0241 13.8472 35.0427 13.9478 34.1494",
    stroke: "#FF48A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9473 11.6826H33.4513C34.8179 11.6826 35.9186 12.7826 35.9186 14.1493V33.6479M27.9473 24.4626H35.9186M27.9473 15.9426H35.9186M27.9473 20.2026H35.9186",
    stroke: "#FF48A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeauty);
export default __webpack_public_path__ + "static/media/beauty.473133c0f4c882c9670db1421311877e.svg";
export { ForwardRef as ReactComponent };